import React from 'react';
import _ from 'lodash';

import ListGroup from 'react-bootstrap/ListGroup';
import { ProjectLinkedState } from 'projects/project-linked-state';
import { useParsedQueryString, useUpdatedTo } from 'projects/project-selector/hooks';
import { useHistory, Route } from 'react-router-dom';
import {
  GcpConsoleButton,
  GcpShellButton,
  PassportButton,
  SmartGCPRequestAccessButton,
} from 'projects/index';
import { getCurrentUser } from 'oauth';
import { ServiceLevel } from './service-level';
import './index.scss';

export const ProjectListItem = ({ project }) => {
  const toProject = useUpdatedTo({ project: project?.projectId });
  const queryString = useParsedQueryString();
  const history = useHistory();
  const isSelected = (queryString?.project === project?.projectId);
  const classes = (isSelected) ? 'selected' : undefined;
  const user = getCurrentUser();
  const handleClick = React.useCallback((event) => {
    _.invoke(event, 'stopPropagation');
    history.replace(toProject);
  }, [history, toProject]);

  return (
    <ListGroup.Item as="li" role="button" action onClick={handleClick} aria-label="GCP Project" className={classes}>
      <div className="rax-mgcp-project-listitem-grid">
        <div className="rax-mgcp-project-listitem-grid__project-name d-flex gap-4">
          <span aria-label="GCP Project Name" className="text-decoration-underline">{project?.name}</span>
          <span aria-label="GCP Project Status"><ProjectLinkedState project={project} /></span>
        </div>
        <small className="rax-mgcp-project-listitem-grid__project-id text-muted" aria-label="GCP Project ID">
          {project?.projectId}
        </small>
        <div className="rax-mgcp-project-listitem-grid__service-blocks" aria-label="GCP Project Service Blocks">
          <ServiceLevel project={project} />
        </div>
        <div className="rax-mgcp-project-listitem-grid__action" aria-label="GCP Project Action">
          <Route path="/racker/customers/:rackspaceAccountNumber">
            <div className="d-flex gap-4 justify-content-end flex-column flex-md-row">
              <SmartGCPRequestAccessButton project={project} />
              <PassportButton project={project} />
            </div>
          </Route>
          <Route path="/projects">
            <div className="d-flex gap-4 flex-column align-items-end flex-md-row-reverse justify-content-md-end">
              <GcpConsoleButton hasAccess className="particles-button--primary w-100" projectId={project.projectId} email={_.get(user, 'email')} />
              <GcpShellButton hasAccess className="w-100" projectId={project.projectId} email={_.get(user, 'email')} />
            </div>
          </Route>
        </div>
      </div>
    </ListGroup.Item>
  );
};
